import { render, staticRenderFns } from "./Repairs.vue?vue&type=template&id=330f632a"
import script from "./Repairs.vue?vue&type=script&lang=js"
export * from "./Repairs.vue?vue&type=script&lang=js"
import style0 from "./Repairs.vue?vue&type=style&index=0&id=330f632a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports